/**Incident creation functionality is there in this component */

import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./CreateIncidentForm.css";
import Modal from "react-bootstrap/Modal";
import MapWrapper from "../../../../Components/UiComponents/MapWrapper/MapWrapper";
import {
  FaFileImage,
  FaFileVideo,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileAlt,
} from "react-icons/fa";
import {
  getThemeURL,
  getTaskConfigsURL,
  getbarches,
  createincident,
  editIncidentdata,
  getallBanksByRole,
  departmentslist
} from "../../../../Services/EndPoints";
import {
  postDataWithBody,
  getData,
  postDataWithFiles,
} from "../../../../Services/Services";

import LocationAutoComplete from "./LocationAutoComplete";
import { XCircleblack } from "../../../../Components/IconComponents";
import {
  validateAddress,
  validateAssignedteam,
  validateAssignTo,
  validateBankName,
  validateBranchName,
  validateCityOrMandal,
  validateContactName,
  validateDate,
  validateDistrict,
  validateEmail,
  validateEventName,
  validateEventType,
  validateIFSCCode,
  validateIncidentDateTime,
  validateLatitude,
  validateLongitude,
  validatePhoneNumber,
  validatePinCode,
  validateResolutionTime,
  validateSeverityLevel,
  validateSource,
  validateWebsite,
  validateAffectedServices,
  validateReportedPersonName,
  validateReportedPersonContactNo,
  validateReporteddate,
  validateSlaTarget,
} from "./IncidentValidations";
import Select from "react-select";
import MapWrapperForEdit from "../../IncidentManagement/AddIncidentForm/MapWarapperForEdit";

const CreateIncidentForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const location = useLocation();
  const { isTextFieldDisable } = location.state || {};
  let data = state?.data;
  let mapview = state?.edit;
  console.log(data, "editdata");

  const [loader, setLoader] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [banksList, setBanksList] = useState([]);
  const [userId, setUserId] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [incidentCategories, setIncidentCategories] = useState([]);
  const [SourceList, setSourceList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [branches, setBranches] = useState([]);
  const [showMapModal, setShowMapModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [coordinates, setCoordinates] = useState([
    {
      y: 85.562, // default longitude
      x: 25.747, // default latitude
    },
  ]);
  // const [mapCenterCoordinates, setMapCenterCoordinates] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(8);
  const [mapKey, setMapKey] = useState(0);
  const [description, setDescription] = useState("");
  const [incidentType, setIncidentType] = useState("bank");
  const [userProfile, setUserProfile] = useState(null);
  const [isRadioDisabled, setIsRadioDisabled] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    bankName: "",
    district: "",
    ifscCode: "",
    entryDate: "",
    addressLine1: "",
    addressLine2: "",
    pinCode: "",
    city: "",
    mandal: "",
    phoneNumber: "",
    email: "",
    contactName: "",
    website: "",
    latitude: "",
    longitude: "",
    eventName: "",
    eventType: "",
    incidentDateTime: "",
    severityLevel: "",
    resolutionTime: "",
    assignedTo: "",
    affectedservices: "",
    reportedpersonname: "",
    reportedpersoncontactno: "",
    reporteddate: "",
    slatarget: "",
    source: "",
    assignedteam: "",
  });
  const [formData, setFormData] = useState({
    // Bank and branch information
    bankName: "",
    branchName: "",

    // Incident details
    eventName: "",
    eventType: "",
    incidentDateTime: "",
    severityLevel: "",
    latitude: "",
    longitude: "",

    // New fields matching API requirements
    source: "",
    affectedservices: "",
    reportedpersonname: "",
    reportedpersoncontactno: "",
    reporteddate: "",
    slatarget: "",
    assignedTeams: "",

    assignedteam: "",
  });

  console.log(formData, "formdata");

  const chooseCoordinates = (longitude, latitude) => {
    setFormData({
      ...formData,
      longitude: longitude,
      latitude: latitude,
    });

    setCoordinates([
      {
        y: longitude,
        x: latitude,
      },
    ]);

    // setMapCenterCoordinates({
    //   y: longitude,
    //   x: latitude,
    // });

    setMapKey((prevKey) => prevKey + 1);
  };

  const updateMapLocation = (lat, lng) => {
    setCoordinates([{ y: lng, x: lat }]);
    setFormData({
      ...formData,
      latitude: lat,
      longitude: lng,
    });
    // setMapCenterCoordinates({
    //   y: lng,
    //   x: lat,
    // });
    setZoomLevel(16);
    setMapKey((prevKey) => prevKey + 1);
  };

  const openMapModal = () => {
    setShowMapModal(true);
  };

  const closeMapModal = () => {
    setShowMapModal(false);
  };

  //fetch user profile, incident details and all roles
  useEffect(() => {
    getUserProfile();
    fetchUserProfile();
    fetchIncidentDetails();
    fetchSourceDetails();
    fetchAllRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (data) {
      const incidentData = data.branch_incident || data;
      // Format datetime properly for the datetime-local input

       let initialIncidentType = "bank"; // default to branch
    if (incidentData.is_bank === true) {
      initialIncidentType = "bank";
    } else if (incidentData.is_branch === true) {
      initialIncidentType = "branch";
    }
    
    setIncidentType(initialIncidentType);
      const formatDateTimeForInput = (dateTimeString) => {
        if (!dateTimeString) return "";

        try {
          // Create a Date object from the string
          let date = new Date(dateTimeString);

          // If the date is invalid, try parsing with different formats
          if (isNaN(date.getTime())) {
            // Handle different date formats
            if (dateTimeString.includes(" ")) {
              // Format: "DD-MM-YYYY HH:MM AM/PM" or "YYYY-MM-DD HH:MM:SS.S"
              const [datePart, timePart] = dateTimeString.split(" ");

              // Check if date is in DD-MM-YYYY format
              if (datePart.match(/^\d{2}-\d{2}-\d{4}$/)) {
                const [day, month, year] = datePart.split("-");
                let [time, period] = timePart.includes("AM") || timePart.includes("PM")
                  ? [timePart.split(" ")[0], timePart.split(" ")[1]]
                  : [timePart, ""];

                let [hours, minutes] = time.split(":");
                // Convert 12-hour format to 24-hour format if needed
                if (period === "PM" && hours !== "12") {
                  hours = parseInt(hours) + 12;
                } else if (period === "AM" && hours === "12") {
                  hours = "00";
                }
                date = new Date(`${year}-${month}-${day}T${hours}:${minutes}`);
              } else {
                // Assume YYYY-MM-DD format
                date = new Date(dateTimeString);
              }
            } else {
              // Handle ISO format
              date = new Date(dateTimeString);
            }
          }

          // Get the timezone offset in minutes and convert to milliseconds
          const timezoneOffset = date.getTimezoneOffset() * 60000;

          // Apply the offset to get local time
          const localDate = new Date(date.getTime() - timezoneOffset);

          // Format to local ISO string and extract just the date and time parts
          return localDate.toISOString().slice(0, 16);
        } catch (error) {
          console.error("Error formatting date:", error, dateTimeString);
          return "";
        }
      };

      // Find the incident category from incidentCategoryId
      const findEventType = () => {
        if (incidentCategories.length > 0 && incidentData.incidentCategoryId) {
          const category = incidentCategories.find(
            (cat) => cat.id === incidentData.incidentCategoryId
          );
          return category ? category.value : "";
        }
        return "";
      };

      // Find the source from sourceId
      const findSource = () => {
        if (SourceList.length > 0 && incidentData.sourceId) {
          const source = SourceList.find(
            (src) => src.id === incidentData.sourceId
          );
          return source ? source.value : "";
        }
        return "";
      };

      // First fetch branches for the selected bank, then set form data
      if (incidentData.bankId) {
        fetchBranches(incidentData.bankId).then(() => {
          // Only set the form data after branches are loaded
          setFormData({
            eventName: incidentData.incidentName || "",
            eventType: findEventType(),
            incidentDateTime: formatDateTimeForInput(
              incidentData.incidentDateAndTime
            ),
            severityLevel: incidentData.severityLevel || "",
            bankName: incidentData.bankId ? incidentData.bankId.toString() : "",
            branchName: incidentData.branchId
              ? incidentData.branchId.toString()
              : "",
            latitude: incidentData.latitude || "",
            longitude: incidentData.longitude || "",
            source: findSource(),
            affectedservices: incidentData.affectedServices || "",
            reportedpersonname: incidentData.reporterName || "",
            reportedpersoncontactno: incidentData.reporterPhone || "",
            reporteddate: formatDateTimeForInput(incidentData.reportedDate),
            slatarget: incidentData.slaTarget || "",
            assignedteam: incidentData.assignedTeam || "",
          });
        });
      } else {
        // If no bankId, still set form data
        setFormData({
          eventName: incidentData.incidentName || "",
          eventType: findEventType(),
          incidentDateTime: formatDateTimeForInput(
            incidentData.incidentDateAndTime
          ),
          severityLevel: incidentData.severityLevel || "",
          bankName: incidentData.bankId ? incidentData.bankId.toString() : "",
          branchName: incidentData.branchId
            ? incidentData.branchId.toString()
            : "",
          latitude: incidentData.latitude || "",
          longitude: incidentData.longitude || "",
          source: findSource(),
          affectedservices: incidentData.affectedServices || "",
          reportedpersonname: incidentData.reporterName || "",
          reportedpersoncontactno: incidentData.reporterPhone || "",
          reporteddate: formatDateTimeForInput(incidentData.reportedDate),
          slatarget: incidentData.slaTarget || "",
          assignedteam: incidentData.assignedTeam || "",
        });
      }
      // Handle description, which needs to go into the textarea
      if (incidentData.description) {
        setTimeout(() => {
          const descriptionEl = document.getElementById("description");
          if (descriptionEl) {
            descriptionEl.value = incidentData.description;
          }
        }, 100);
      }

      // Handle attached files/images - properly format existing images from S3
      if (incidentData.mediaList && incidentData.mediaList.length > 0) {
        const existingImages = incidentData.mediaList.map((media) => ({
          id: media.id,
          preview: media.mediaPath,
          isExisting: true, // Flag to indicate this is an existing image from the server
        }));
        setSelectedImages(existingImages);
      }
      // If coordinates are available, update the map
      if (incidentData.latitude && incidentData.longitude) {
        setCoordinates([
          {
            y: parseFloat(incidentData.longitude),
            x: parseFloat(incidentData.latitude),
          },
        ]);

        // setMapCenterCoordinates({
        //   y: parseFloat(incidentData.longitude),
        //   x: parseFloat(incidentData.latitude),
        // });
      }
    }
  }, [data, incidentCategories, SourceList]);
  // Fetch branches whenever bankName changes

  //fileicon funtion
  const getFileIcon = (fileType) => {
    switch (fileType) {
      case "image/jpeg":
      case "image/jpg":
      case "image/png":
        return <FaFileImage />;
      case "video/mp4":
        return <FaFileVideo />;
      case "application/pdf":
        return <FaFilePdf />;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return <FaFileWord />;
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return <FaFileExcel />;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return <FaFilePowerpoint />;
      default:
        return <FaFileAlt />;
    }
  };

  //to fetch branches of that bank
  useEffect(() => {
    if (formData.bankName) {
      fetchBranches(formData.bankName);
    }
  }, [formData.bankName]);

  useEffect(() => {
    if (
      data?.branch_incident?.incidentCategoryId &&
      incidentCategories.length > 0
    ) {
      const foundCategory = incidentCategories.find(
        (category) => category.id === data.branch_incident.incidentCategoryId
      );

      if (foundCategory) {
        setFormData((prev) => ({
          ...prev,
          eventType: foundCategory.value,
        }));
      }
    }
  }, [data, incidentCategories]);

  // Function to fetch branches based on selected bank
  const fetchBranches = async (bankId) => {
    setLoader(true);
    try {
      // Replace with your actual endpoint to get branches by bank ID
      const response = await getData(getbarches.replace("ID", bankId));
      if (response && Array.isArray(response)) {
        // Filter branches to only include those matching the selected bankId
        const filteredBranches = response.filter(
          (branch) =>
            branch.bankId === bankId ||
            branch.bankId.toString() === bankId.toString()
        );
        setBranches(filteredBranches);
      } else {
        console.error("Invalid branches data format:", response);
        toast.error("Failed to load branches data");
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
      toast.error("Failed to load branches data");
    } finally {
      setLoader(false);
    }
    // Return a resolved promise so we can chain with .then()
    return Promise.resolve();
  };
  // Handle form input changes
  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;
    if (type === "checkbox" && id === "activeStatusCheck") {
      setFormData({ ...formData, activeStatus: checked });
    } else {
      setFormData({ ...formData, [id]: value });

     // If bank is changed, fetch branches and reset branch selection
    if (id === "bankName" && value) {
      const currentBankId = formData.bankName;
      const newBankId = value;

      // Only fetch branches if we're in branch mode or if branch selection is allowed
      if (incidentType === "branch") {
        fetchBranches(value);
      }

      if (currentBankId && currentBankId !== newBankId) {
        setFormData((prevData) => ({ ...prevData, branchName: "" }));
      }
    }

      // Validate fields on change
      let error = "";
      switch (id) {
        case "bankName":
          error = validateBankName(value);
          break;
        case "branchName":
          error = validateBranchName(value);
          break;
        case "district":
          error = validateDistrict(value);
          break;
        case "ifscCode":
          error = validateIFSCCode(value);
          break;
        case "entryDate":
          error = validateDate(value);
          break;
        case "addressLine1":
          error = validateAddress(value, "Address Line", true);
          break;
        case "addressLine2":
          error = validateAddress(value, "Address Line 2", false);
          break;
        case "pinCode":
          error = validatePinCode(value);
          break;
        case "city":
          error = validateCityOrMandal(value, "City");
          break;
        case "mandal":
          error = validateCityOrMandal(value, "Mandal");
          break;
        case "phoneNumber":
          error = validatePhoneNumber(value);
          break;
        case "email":
          error = validateEmail(value);
          break;
        case "contactName":
          error = validateContactName(value);
          break;
        case "latitude":
          error = validateLatitude(value);
          break;
        case "longitude":
          error = validateLongitude(value);
          break;
        case "eventName":
          error = validateEventName(value);
          break;
        case "eventType":
          error = validateEventType(value);
          break;
        case "incidentDateTime":
          error = validateIncidentDateTime(value);
          break;
        case "severityLevel":
          error = validateSeverityLevel(value);
          break;
        case "resolutionTime":
          error = validateResolutionTime(value);
          break;
        case "assignedTo":
          error = validateAssignTo(value);
          break;
        case "website":
          error = validateWebsite(value);
          break;
        case "source":
          error = validateSource(value);
          break;
        case "affectedservices":
          error = validateAffectedServices(value);
          break;
        case "reportedpersonname":
          error = validateReportedPersonName(value);
          break;
        case "reportedpersoncontactno":
          error = validateReportedPersonContactNo(value);
          break;
        case "reporteddate":
          error = validateReporteddate(value);
          break;
        case "slatarget":
          error = validateSlaTarget(value);
          break;
        case "assignedteam":
          error = validateAssignedteam(value);
          break;
        default:
          break;
      }

      setValidationErrors({
        ...validationErrors,
        [id]: error,
      });
    }
  };

const getUserProfile = async () => {
  try {
    const userProfile = await getData(getThemeURL);
    if (userProfile && userProfile.length > 0) {
      const profile = userProfile[0];
      setUserProfile(profile);
      
      // Set radio button state based on role and profile
      if (profile.is_admin !== true && profile.role_name === "SUPER ADMIN") {
        setIsRadioDisabled(true);
        
        // If user has both bank_id and branch_id, set to branch and auto-select branch
        if (profile.bank_id && profile.branch_id) {
          setIncidentType("branch");
          // Auto-select the user's branch
          setFormData(prev => ({
            ...prev,
            branchName: profile.branch_id.toString()
          }));
        }
        // If user has only bank_id, set to bank
        else if (profile.bank_id && !profile.branch_id) {
          setIncidentType("bank");
        }
      }
      
      fetchBanks(profile);
    }
  } catch (error) {
    console.error("Error fetching user profile:", error);
    toast.error("Failed to fetch user profile", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
    });
  }
};
  const createPayload = (profile) => {
    let admin_role;
 
    if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    } else if (profile.is_admin === true) {
      admin_role = "HO";
    } else {
      admin_role = "U";
    }
 
    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  // Fetch banks from API
const fetchBanks = async (profile) => {
  setLoader(true);
  try {
    const payload = createPayload(profile);
    const response = await postDataWithBody(getallBanksByRole, payload, {});
    if (response && Array.isArray(response)) {
      setBanksList(response);
      
      // Automatically set the first bank in formData and fetch its branches
      if (response.length > 0) {
        const firstBank = response[0];
        setFormData(prevData => ({
          ...prevData,
          bankName: firstBank.id.toString() // Set bank ID in formData
        }));
        
        // Automatically fetch branches for the first bank
        fetchBranches(firstBank.id).then(() => {
          // After branches are loaded, auto-select the user's branch if they are a branch user
          if (profile.branch_id) {
            setFormData(prev => ({
              ...prev,
              branchName: profile.branch_id.toString()
            }));
          }
        });
      }
    } else {
      console.error("Invalid banks data format:", response);
      toast.error("Failed to load banks data");
    }
  } catch (error) {
    console.error("Error fetching banks:", error);
    toast.error("Failed to load banks data");
  } finally {
    setLoader(false);
  }
};


  const fetchUserProfile = async () => {
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        setUserId(response[0].id); // Get `id` from the first user
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const fetchIncidentDetails = async () => {
    try {
      let response = await postDataWithBody(
        getTaskConfigsURL,
        ["INCDNT_CAT"],
        {}
      );

      if (response && Array.isArray(response)) {
        // Store the incident categories in state
        setIncidentCategories(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };

  //to fetch incident category
  const fetchSourceDetails = async () => {
    try {
      let response = await postDataWithBody(
        getTaskConfigsURL,
        ["BRCH_SRC_SYS_ORG"],
        {}
      );

      if (response && Array.isArray(response)) {
        // Store the incident categories in state
        setSourceList(response);
      } else {
        console.error("Invalid incident category data format:", response);
        toast.error("Failed to load incident categories");
      }
    } catch (error) {
      console.error("Error fetching incident categories:", error);
      toast.error("Failed to load incident categories");
    }
  };

  const fetchAllRoles = async () => {
    // setLoader(true);
    try {
      const rolearr = await getData(departmentslist);
      const sortedRoles = rolearr.sort((a, b) => (a.name > b.name ? 1 : -1));

      const roleList = sortedRoles.map((role) => ({
        label: role.name,
        value: role.id,
      }));

      setRoleList(roleList);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to load roles");
    } finally {
      // setLoader(false);
    }
  };

  //upload image related
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const validExtensions = [
      "jpg", "jpeg", "png", "pdf", "mp4",
      "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt"
    ];

    let validFilesCount = selectedImages.length;

    for (const file of files) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileSizeMB = file.size / (1024 * 1024);

      if (!validExtensions.includes(fileExtension)) {
        toast.error(`File type ${fileExtension} not allowed.`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        continue;
      }

      if (fileSizeMB > 1) {
        toast.error(`"${file.name}" exceeds 1MB size limit.`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        continue;
      }

      if (validFilesCount >= 3) {
        toast.error("You can only upload up to 3 files.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        break;
      }


      const reader = new FileReader();

      reader.onloadend = () => {
        const fileType = file.type.split("/")[0];
        const filePreview = {
          file,
          preview: reader.result,
          type: fileType,
          extension: fileExtension,
          name: file.name,
        };

        setSelectedImages((prevFiles) => [...prevFiles, filePreview]);
      };

      reader.readAsDataURL(file);
      validFilesCount++;
    }

    e.target.value = ""; // allow re-selection of same file
  };


  //upload image related
  const removeImage = (indexToRemove) => {
    setSelectedImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
  };

  const validateForm = () => {
    const errors = {
      latitude: validateLatitude(formData.latitude),
      longitude: validateLongitude(formData.longitude),
      eventName: validateEventName(formData.eventName),
      eventType: validateEventType(formData.eventType),
      incidentDateTime: validateIncidentDateTime(formData.incidentDateTime),
      severityLevel: validateSeverityLevel(formData.severityLevel),
      bankName: validateBankName(formData.bankName),
      branchName: incidentType === "branch" ? validateBranchName(formData.branchName) : "",
      source: validateSource(formData.source),
      affectedservices: validateAffectedServices(formData.affectedservices),
      reportedpersonname: validateReportedPersonName(
        formData.reportedpersonname
      ),
      reportedpersoncontactno: validateReportedPersonContactNo(
        formData.reportedpersoncontactno
      ),
      reporteddate: validateReporteddate(formData.reporteddate),
      slatarget: validateSlaTarget(formData.slatarget),
      assignedteam: validateAssignedteam(formData.assignedteam),
    };

    setValidationErrors(errors);

    // Debug: Log which fields are failing validation
    Object.entries(errors).forEach(([field, error]) => {
      if (error !== "") {
        console.log(`Validation failed for ${field}: ${error}`);
      }
    });
    // Form is valid if no error messages exist
    return !Object.values(errors).some((error) => error !== "");
  };

  const handleSubmit = async () => {
    // Validate form before submission
    if (!validateForm()) {
      toast.error("Please correct the validation errors", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
      return;
    }

    setIsSubmitting(true);
    setLoader(true);

    try {
      // Format the incident date and time
      const formatDateTime = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);

        // For create operation, we want to keep the local time as-is
        // For edit operation, we need to preserve the original time
        if (!data) {
          // Create operation - use local time values directly
          const formattedDate = date
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .replace(/\//g, "-");

          const formattedTime = date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

          return `${formattedDate} ${formattedTime}`;
        } else {
          // Edit operation - handle existing dates carefully
          // If the date hasn't changed, use the original value
          if (data.branch_incident &&
            new Date(data.branch_incident.incidentDateAndTime).getTime() === date.getTime()) {
            return data.branch_incident.incidentDateAndTime;
          }

          // If changed, format as new local time
          const formattedDate = date
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .replace(/\//g, "-");

          const formattedTime = date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

          return `${formattedDate} ${formattedTime}`;
        }
      };

      const incidentDateAndTimeString = formatDateTime(formData.incidentDateTime);
      const reportedDateString = formatDateTime(formData.reporteddate);

       const isBankIncident = incidentType === "bank";
       const isBranchIncident = incidentType === "branch"

      // Rest of your existing code for building the payload...
      const selectedCategory = incidentCategories.find(
        (category) => category.value === formData.eventType
      );
      const incidentCategoryId = selectedCategory ? selectedCategory.id : null;

      const selectedSource = SourceList.find(
        (source) => source.value === formData.source
      );
      const sourceId = selectedSource ? selectedSource.id : null;

      const incidentPayload = {
        incidentName: formData.eventName,
        incidentCategoryId: incidentCategoryId,
        incidentDateAndTimeString: incidentDateAndTimeString,
        severityLevel: formData.severityLevel,
        bankId: parseInt(formData.bankName),
        branchId: parseInt(formData.branchName),
        latitude: formData.latitude,
        longitude: formData.longitude,
        description: document.getElementById("description").value,
        sourceId: sourceId,
        affectedServices: formData.affectedservices,
        reporterName: formData.reportedpersonname,
        reporterPhone: formData.reportedpersoncontactno,
        reportedDateString: reportedDateString,
        slaTarget: formData.slatarget,
        assignedTeam: formData.assignedteam,
        is_deleted: false,
        is_bank: isBankIncident,
      is_branch: isBranchIncident,
      };

      // Handle edit vs create differences
      const isEditMode = data && (data.id || (data.branch_incident && data.branch_incident.id));
      if (isEditMode) {
        incidentPayload.id = data.id || data.branch_incident.id;
        incidentPayload.updated_by = userId;
        incidentPayload.incidentId = data.incidentId || data.branch_incident.incidentId;
        // incidentPayload.is_event_created = true;
        incidentPayload.createdBy = userId;
      } else {
        incidentPayload.createdBy = userId;
      }
// ... existing code ...

// Create FormData object for multipart/form-data submission
const formDataToSend = new FormData();

// Add the branch_incident JSON as a string
formDataToSend.append("branch_incident", JSON.stringify(incidentPayload));

// Handle file attachments based on different scenarios
const handleFileAttachments = () => {
  // Scenario 1: No images attached at all
  if (selectedImages.length === 0) {
    // Send an empty file array indicator
    formDataToSend.append("files", new Blob([], { type: 'application/octet-stream' }), "empty.bin");
    return;
  }

  // Scenario 2: Images are attached (new or existing)
  const existingImageIds = [];
  let hasNewFiles = false;

  selectedImages.forEach((imgObj) => {
    if (imgObj.file instanceof File) {
      // Newly uploaded file
      formDataToSend.append("files", imgObj.file);
      hasNewFiles = true;
    } else if (imgObj.isExisting && imgObj.id) {
      // Existing image from server
      existingImageIds.push(imgObj.id);
    }
  });

  // Handle existing image IDs for edit mode
  if (isEditMode && existingImageIds.length > 0) {
    incidentPayload.existingMediaIds = existingImageIds;
    formDataToSend.set("branch_incident", JSON.stringify(incidentPayload));
  }

  // Scenario 3: Edit mode with only existing images (no new files)
  if (isEditMode && !hasNewFiles && existingImageIds.length > 0) {
    // API expects files field even if only keeping existing images
    formDataToSend.append("files", new Blob([]), "keep-existing.bin");
  }
};

handleFileAttachments();

// ... rest of your code ...
      const response = isEditMode
        ? await postDataWithFiles(editIncidentdata, formDataToSend)
        : await postDataWithFiles(createincident, formDataToSend);

      if (response.status === "success") {
        toast.success(
          isEditMode
            ? "Incident updated successfully"
            : "Incident created successfully",
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          }
        );
        navigate("../All_Incidents");
      } else {
        toast.error(
          response.msg ||
          (isEditMode
            ? "Failed to update incident"
            : "Failed to create incident"),
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          }
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An error occurred while submitting the form", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
      setIsSubmitting(false);
    }
  };
  const roleOptions = roleList.map((category) => ({
    value: category.value,
    label: category.label,
  }));

  const mapCoordinates = [
    {
      x: formData.latitude,
      y: formData.longitude,
      locationId: 1,
    },
  ];
  const handleCancel = () => {
    setShowCancelModal(true);
  };
  const confirmCancel = () => {
    resetForm();
    setShowCancelModal(false);
  };
const handleIncidentTypeChange = (e) => {
  const selectedType = e.target.value;
  setIncidentType(selectedType);
  
  // Clear validation errors when switching types
  setValidationErrors({
    ...validationErrors,
    bankName: "",
    branchName: "",
  });
  
  // Handle type-specific logic
  if (selectedType === "bank") {
    // Clear branch when switching to bank
    setFormData({
      ...formData,
      branchName: "",
    });
    setBranches([]); // Clear branches list
  } else if (selectedType === "branch") {
    // When switching to branch, clear branch selection but refetch branches if bank is selected
    setFormData({
      ...formData,
      branchName: "", // Clear current branch selection
    });
    
    // If a bank is already selected, fetch its branches
    if (formData.bankName) {
      fetchBranches(formData.bankName);
    }
  }
};

  // Close cancel modal without resetting
  const closeCancelModal = () => {
    setShowCancelModal(false);
  };
  const resetForm = () => {
    // Reset main form data
    setFormData({
      bankName: "",
      branchName: "",

      // Incident details
      eventName: "",
      eventType: "",
      incidentDateTime: "",
      severityLevel: "",
      latitude: "",
      longitude: "",
      source: "",
      affectedservices: "",
      reportedpersonname: "",
      reportedpersoncontactno: "",
      reporteddate: "",
      slatarget: "",
      assignedTeams: "",
      assignedteam: "",
    });
    setDescription("");
    setSelectedImages([]);

    // Reset working days
    // Reset coordinates for map
    setCoordinates([
      {
        y: 85.562, // default longitude
        x: 25.747, // default latitude
      },
    ]);

    // Reset validation errors
    setValidationErrors({
      bankName: "",
      district: "",
      ifscCode: "",
      entryDate: "",
      addressLine1: "",
      addressLine2: "",
      pinCode: "",
      city: "",
      mandal: "",
      phoneNumber: "",
      email: "",
      contactName: "",
      website: "",
      latitude: "",
      longitude: "",
      eventName: "",
      eventType: "",
      incidentDateTime: "",
      severityLevel: "",
      resolutionTime: "",
      assignedTo: "",
      affectedservices: "",
      reportedpersonname: "",
      reportedpersoncontactno: "",
      reporteddate: "",
      slatarget: "",
      source: "",
      assignedteam: "",
    });
  };

  return (
    <>
      {!mapview ? (
        <>
          {/* incident details */}
          <div class="main-container mt-4">
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="eventName" class="form-label">
                  Incident Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.eventName ? "is-invalid" : ""
                    }`}
                  id="eventName"
                  value={formData.eventName}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.eventName && (
                  <div className="invalid-feedback">
                    {validationErrors.eventName}
                  </div>
                )}
              </div>
              <div class="col-md-6">
                <label for="eventType" class="form-label">
                  Incident Category<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.eventType ? "is-invalid" : ""
                    }`}
                  id="eventType"
                  value={formData.eventType}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Choose incident category
                  </option>
                  {incidentCategories.map((category) => (
                    <option key={category.id} value={category.value}>
                      {category.value}
                    </option>
                  ))}
                </select>
                {validationErrors.eventType && (
                  <div className="invalid-feedback">
                    {validationErrors.eventType}
                  </div>
                )}
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <label for="incidentDateTime" class="form-label">
                  Incident Date & Time<span className="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  className={`form-control branch-input-form-control ${validationErrors.incidentDateTime ? "is-invalid incident-date-validation" : ""
                    }`}
                  id="incidentDateTime"
                  value={formData.incidentDateTime}
                  onChange={handleInputChange}
                />

                {validationErrors.incidentDateTime && (
                  <div className="invalid-feedback">
                    {validationErrors.incidentDateTime}
                  </div>
                )}
              </div>
              <div class="col-md-6">
                <label for="severityLevel" class="form-label">
                  Severity Level<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.severityLevel ? "is-invalid" : ""
                    }`}
                  id="severityLevel"
                  value={formData.severityLevel}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Select Severity
                  </option>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </select>

                {validationErrors.severityLevel && (
                  <div className="invalid-feedback">
                    {validationErrors.severityLevel}
                  </div>
                )}
              </div>
            </div>

  
  <div className="col-12 mb-3">
  <label className="form-label">
    Incident Type<span className="text-danger">*</span>
  </label>
  <div className="d-flex gap-4">
    <div className="form-check">
      <input
        className="form-check-input"
        type="radio"
        name="incidentType"
        id="bankIncident"
        value="bank"
        checked={incidentType === "bank"}
        onChange={handleIncidentTypeChange}
        disabled={isRadioDisabled}
      />
      <label className="form-check-label" htmlFor="bankIncident">
        Bank Level Incident
      </label>
    </div>
    <div className="form-check">
      <input
        className="form-check-input"
        type="radio"
        name="incidentType"
        id="branchIncident"
        value="branch"
        checked={incidentType === "branch"}
        onChange={handleIncidentTypeChange}
        disabled={isRadioDisabled}
      />
      <label className="form-check-label" htmlFor="branchIncident">
        Branch Level Incident
      </label>
    </div>
  </div>
  {isRadioDisabled && (
    <small className="text-muted">
      Incident type is automatically set based on your role permissions.
    </small>
  )}
</div>
            <div class="row mb-3">
              <div className="col-md-6">
  <label htmlFor="bankName" className="form-label">
    Bank Name<span className="text-danger">*</span>
  </label>
  <input
    type="text"
    className="form-control branch-input-form-control"
    id="bankName"
    value={banksList.length > 0 ? banksList[0].bankName : ""}
    disabled
  />
  {/* Keep the ID in a hidden field if you need to submit it */}
  <input
    type="hidden"
    name="bankName"
    value={banksList.length > 0 ? banksList[0].id : ""}
  />
</div>



             <div className="col-md-6">
  <label htmlFor="branchName" className="form-label">
    Branch Name
    {incidentType === "branch" && <span className="text-danger">*</span>}
  </label>
  <select
    className={`form-control branch-input-form-control ${
      validationErrors.branchName ? "is-invalid" : ""
    }`}
    id="branchName"
    value={formData.branchName}
    onChange={handleInputChange}
    disabled={incidentType === "bank" || (userProfile && userProfile.branch_id)} // Disable when bank is selected OR user is branch user
  >
    <option value="" disabled>
      {incidentType === "bank" 
        ? "NA"
        : formData.bankName
          ? "Select Branch"
          : "Please select a bank first"
      }
    </option>
    {branches.map((branch) => (
      <option key={branch.id} value={branch.id}>
        {branch.branchName}
      </option>
    ))}
  </select>
  {validationErrors.branchName && (
    <div className="invalid-feedback">
      {validationErrors.branchName}
    </div>
  )}
  
  {/* Display the branch name for branch users */}
  {userProfile && userProfile.branch_id && (
    <input
      type="hidden"
      value={formData.branchName}
    />
  )}
</div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="eventType" class="form-label">
                  Source<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.source ? "is-invalid" : ""
                    }`}
                  id="source"
                  value={formData.source}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Choose source
                  </option>
                  {SourceList.map((category) => (
                    <option key={category.id} value={category.value}>
                      {category.value}
                    </option>
                  ))}
                </select>
                {validationErrors.source && (
                  <div className="invalid-feedback">
                    {validationErrors.source}
                  </div>
                )}
              </div>
              <div class="col-md-6">
                <label for="affectedservices" class="form-label">
                  Affected Services<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.affectedservices ? "is-invalid" : ""
                    }`}
                  id="affectedservices"
                  value={formData.affectedservices}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.affectedservices && (
                  <div className="invalid-feedback">
                    {validationErrors.affectedservices}
                  </div>
                )}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-4">
                <label for="reportedpersonname" class="form-label">
                  Reporter Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.reportedpersonname ? "is-invalid" : ""
                    }`}
                  id="reportedpersonname"
                  value={formData.reportedpersonname}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.reportedpersonname && (
                  <div className="invalid-feedback">
                    {validationErrors.reportedpersonname}
                  </div>
                )}
              </div>
              <div class="col-md-4">
                <label for="reportedpersoncontactno" class="form-label">
                  Reporter Mobile/Landline Number:
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.reportedpersoncontactno ? "is-invalid" : ""
                    }`}
                  id="reportedpersoncontactno"
                  value={formData.reportedpersoncontactno}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.reportedpersoncontactno && (
                  <div className="invalid-feedback">
                    {validationErrors.reportedpersoncontactno}
                  </div>
                )}
              </div>
              <div class="col-md-4">
                <label for="reporteddate" class="form-label">
                  Reported Date & Time<span className="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  className={`form-control branch-input-form-control ${validationErrors.reporteddate ? "is-invalid incident-date-validation" : ""
                    }`}
                  id="reporteddate"
                  value={formData.reporteddate}
                  onChange={handleInputChange}
                />

                {validationErrors.reporteddate && (
                  <div className="invalid-feedback">
                    {validationErrors.reporteddate}
                  </div>
                )}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="slatarget" class="form-label">
                  SLA Target<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.slatarget ? "is-invalid" : ""
                    }`}
                  id="slatarget"
                  value={formData.slatarget}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.slatarget && (
                  <div className="invalid-feedback">
                    {validationErrors.slatarget}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="assignedteam" className="form-label">
                  Assigned Team<span className="text-danger">*</span>
                </label>
                <Select
                  isMulti
                  name="assignedteam"
                  options={roleOptions}
                  value={
                    formData.assignedteam
                      ? formData.assignedteam
                        .split(",")
                        .map((team) => {
                          const option = roleOptions.find(
                            (opt) =>
                              opt.value.toString() === team.trim() ||
                              opt.label === team.trim()
                          );
                          return option ? option : null;
                        })
                        .filter(Boolean)
                      : []
                  }
                  onChange={(selected) => {
                    const selectedValues = selected
                      .map((option) => option.value)
                      .join(",");
                    setFormData({
                      ...formData,
                      assignedteam: selectedValues,
                    });

                    // Clear any validation errors
                    setValidationErrors({
                      ...validationErrors,
                      assignedteam: "",
                    });
                  }}
                  classNamePrefix="react-select"
                  className={validationErrors.assignedteam ? "is-invalid" : ""}
                />
                {validationErrors.assignedteam && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.assignedteam}
                  </div>
                )}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <label for="description" class="form-label">
                  Incident Description
                </label>
                <textarea
                  class="form-control"
                  id="description"
                  rows="3"
                  maxLength="250"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                // placeholder="Assign to relevant response team..."
                ></textarea>
                <small className="text-muted">Maximum 250 characters</small>
              </div>

              <div className="col-md-6">
                <label htmlFor="attachments" className="form-label">
                  Attachments (Images, Videos & Documents)
                </label>
                <input
                  type="file"
                  className="form-control branch-input-form-control"
                  id="attachments"
                  accept=".jpg, .jpeg, .png, .pdf, .mp4, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt"
                  onChange={handleImageChange}
                  multiple
                />
                <div className="mt-3 d-flex flex-wrap">
                  {selectedImages.map((fileObj, index) => {
                    const name = fileObj.name || fileObj.preview || "";
                    const dotIndex = name.lastIndexOf(".");
                    const namePrefix = name.slice(0, 4);
                    const extension =
                      dotIndex !== -1 ? name.slice(dotIndex) : "";
                    const shortName = `${namePrefix}${extension}`;

                    return (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          margin: "5px",
                          display: "inline-block",
                          textAlign: "center",
                          width: "100px",
                        }}
                      >
                        {fileObj.type && fileObj.type.startsWith("image") ? (
                          <img
                            src={fileObj.preview}
                            alt={`preview-${index}`}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "100px",
                              height: "100px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "4px",
                              backgroundColor: "#f0f0f0",
                            }}
                          >
                            {getFileIcon(fileObj.type)}
                          </div>
                        )}

                        <span
                          style={{
                            display: "block",
                            fontSize: "12px",
                            marginTop: "4px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={name}
                        >
                          {shortName}
                        </span>

                        <button
                          onClick={() => removeImage(index)}
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            color: "black",
                            background: "white",
                            border: "none",
                            borderRadius: "50%",
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          title="Remove file"
                        >
                          ✖
                        </button>
                      </div>
                    );
                  })}
                </div>

              </div>
            </div>
            <div class="row mb-3">
              <div className="col-md-6">
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="latitude" className="form-label mb-0">
                    Latitude
                  </label>
                </div>
                <input
                  type="text"
                  className="form-control branch-input-form-control mt-1"
                  id="latitude"
                  value={formData.latitude}
                  onChange={handleInputChange}
                  disabled={isTextFieldDisable}
                  readOnly
                />
                {validationErrors.latitude && (
                  <div className="text-danger small">
                    {validationErrors.latitude}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <label htmlFor="longitude" className="form-label">
                    Longitude
                  </label>
                  <span
                    className="text-primary"
                    onClick={!isTextFieldDisable ? openMapModal : undefined}
                    style={{
                      cursor: isTextFieldDisable ? "not-allowed" : "pointer",
                      opacity: isTextFieldDisable ? 0.5 : 1,
                    }}
                  >
                    Locate on map
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control branch-input-form-control"
                  id="longitude"
                  value={formData.longitude}
                  onChange={handleInputChange}
                  disabled={isTextFieldDisable}
                  readOnly
                />
                {validationErrors.longitude && (
                  <div className="text-danger small">
                    {validationErrors.longitude}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* map view */}
          {mapview && (
            <div style={{ width: "50%", height: "100%" }}>
              <MapWrapperForEdit
                bankEdit={true}
                title="Incidents"
                containerStyles={{
                  height: "100%",
                  borderRadius: "10px",
                  // height: "100vh",
                  display: "flex",
                  flexDirection: "column",
                }}
                headerStyles={{
                  backgroundColor: "#1a7a73",
                  color: "white",
                  padding: "8px 16px",
                }}
                bodyStyles={{
                  flex: 1,
                  overflow: "hidden",
                }}
                coordinates={mapCoordinates}
                zoom={13}
                popUpShow={true}
              />
            </div>
          )}

          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "4rem" }}
          >
            <button
              className="branch-save-submit-btn btn btn-success"
              onClick={handleSubmit}
              disabled={isSubmitting || isTextFieldDisable}
            >
              {isSubmitting
                ? "Submitting..."
                : data
                  ? "Update"
                  : "Save & Submit"}
            </button>
            <button
              type="button"
              className="branch-save-submit-btn btn btn-success"
              style={{ marginLeft: "15px" }}
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>

          {/* Display loading indicator */}
          {loader && (
            <div className="loader-container">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {showMapModal && (
            <Modal
              className="modal-position"
              size="lg"
              show={showMapModal}
              onHide={closeMapModal}
              aria-labelledby="example-modal-sizes-title-lg"
              right
            >
              <Modal.Header>
                <Modal.Title
                  id="example-modal-sizes-title-lg"
                  style={{ color: "#001b30", marginRight: "500px" }}
                >
                  {"Choose Location"}
                </Modal.Title>
                <XCircleblack
                  className="cursor-pointer"
                  onClick={closeMapModal}
                  width="1.5em"
                  height="1.5em"
                  style={{ color: "#001b30" }}
                />
              </Modal.Header>
              <Modal.Body>
                <div className="gis-mapcontainer">
                  <LocationAutoComplete updateMapLocation={updateMapLocation} />

                  <div key={mapKey} className="assetFormMap">
                    <MapWrapper
                      headerStyles={{ display: "none" }}
                      coordinates={coordinates}
                      chooseCoordinates={chooseCoordinates}
                      zoom={zoomLevel}
                      closeMapModal={closeMapModal}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}

          <ToastContainer />
        </>
      ) : (
        <>
          <div class="main-container mt-4">
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="eventName" class="form-label">
                  Incident Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.eventName ? "is-invalid" : ""
                    }`}
                  id="eventName"
                  value={formData.eventName}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.eventName && (
                  <div className="invalid-feedback">
                    {validationErrors.eventName}
                  </div>
                )}
              </div>
              <div class="col-md-6">
                <label for="eventType" class="form-label">
                  Incident Category<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.eventType ? "is-invalid" : ""
                    }`}
                  id="eventType"
                  value={formData.eventType}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Choose incident category
                  </option>
                  {incidentCategories.map((category) => (
                    <option key={category.id} value={category.value}>
                      {category.value}
                    </option>
                  ))}
                </select>
                {validationErrors.eventType && (
                  <div className="invalid-feedback">
                    {validationErrors.eventType}
                  </div>
                )}
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-6">
                <label for="incidentDateTime" class="form-label">
                  Incident Date & Time<span className="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  className={`form-control branch-input-form-control ${validationErrors.incidentDateTime ? "is-invalid" : ""
                    }`}
                  id="incidentDateTime"
                  value={formData.incidentDateTime}
                  onChange={handleInputChange}
                />

                {validationErrors.incidentDateTime && (
                  <div className="invalid-feedback">
                    {validationErrors.incidentDateTime}
                  </div>
                )}
              </div>
              <div class="col-md-6">
                <label for="severityLevel" class="form-label">
                  Severity Level<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.severityLevel ? "is-invalid" : ""
                    }`}
                  id="severityLevel"
                  value={formData.severityLevel}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Select Severity
                  </option>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </select>

                {validationErrors.severityLevel && (
                  <div className="invalid-feedback">
                    {validationErrors.severityLevel}
                  </div>
                )}
              </div>
            </div>
           <div className="col-12 mb-3">
  <label className="form-label">
    Incident Type<span className="text-danger">*</span>
  </label>
  <div className="d-flex gap-4">
    <div className="form-check">
      <input
        className="form-check-input"
        type="radio"
        name="incidentType"
        id="bankIncident"
        value="bank"
        checked={incidentType === "bank"}
        onChange={handleIncidentTypeChange}
        disabled={isRadioDisabled}
      />
      <label className="form-check-label" htmlFor="bankIncident">
        Bank Level Incident
      </label>
    </div>
    <div className="form-check">
      <input
        className="form-check-input"
        type="radio"
        name="incidentType"
        id="branchIncident"
        value="branch"
        checked={incidentType === "branch"}
        onChange={handleIncidentTypeChange}
        disabled={isRadioDisabled}
      />
      <label className="form-check-label" htmlFor="branchIncident">
        Branch Level Incident
      </label>
    </div>
  </div>
  {isRadioDisabled && (
    <small className="text-muted">
      Incident type is automatically set based on your role permissions.
    </small>
  )}
</div>
            <div class="row mb-3">
              <div className="col-md-6">
  <label htmlFor="bankName" className="form-label">
    Bank Name<span className="text-danger">*</span>
  </label>
  <input
    type="text"
    className="form-control branch-input-form-control"
    id="bankName"
    value={banksList.length > 0 ? banksList[0].bankName : ""}
    disabled
  />
  {/* Keep the ID in a hidden field if you need to submit it */}
  <input
    type="hidden"
    name="bankName"
    value={banksList.length > 0 ? banksList[0].id : ""}
  />
</div>



              <div className="col-md-6">
  <label htmlFor="branchName" className="form-label">
    Branch Name
    {incidentType === "branch" && <span className="text-danger">*</span>}
  </label>
  <select
    className={`form-control branch-input-form-control ${
      validationErrors.branchName ? "is-invalid" : ""
    }`}
    id="branchName"
    value={formData.branchName}
    onChange={handleInputChange}
    disabled={incidentType === "bank" || (userProfile && userProfile.branch_id)} // Disable when bank is selected OR user is branch user
  >
    <option value="" disabled>
      {incidentType === "bank" 
        ? "NA"
        : formData.bankName
          ? "Select Branch"
          : "Please select a bank first"
      }
    </option>
    {branches.map((branch) => (
      <option key={branch.id} value={branch.id}>
        {branch.branchName}
      </option>
    ))}
  </select>
  {validationErrors.branchName && (
    <div className="invalid-feedback">
      {validationErrors.branchName}
    </div>
  )}
  
  {/* Display the branch name for branch users */}
  {userProfile && userProfile.branch_id && (
    <input
      type="hidden"
      value={formData.branchName}
    />
  )}
</div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="eventType" class="form-label">
                  Source<span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select branch-input-form-control ${validationErrors.source ? "is-invalid" : ""
                    }`}
                  id="source"
                  value={formData.source}
                  onChange={handleInputChange}
                >
                  <option value="" disabled>
                    Choose source
                  </option>
                  {SourceList.map((category) => (
                    <option key={category.id} value={category.value}>
                      {category.value}
                    </option>
                  ))}
                </select>
                {validationErrors.source && (
                  <div className="invalid-feedback">
                    {validationErrors.source}
                  </div>
                )}
              </div>
              <div class="col-md-6">
                <label for="affectedservices" class="form-label">
                  Affected Services<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.affectedservices ? "is-invalid" : ""
                    }`}
                  id="affectedservices"
                  value={formData.affectedservices}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.affectedservices && (
                  <div className="invalid-feedback">
                    {validationErrors.affectedservices}
                  </div>
                )}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-4">
                <label for="reportedpersonname" class="form-label">
                  Reporter Name<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.reportedpersonname ? "is-invalid" : ""
                    }`}
                  id="reportedpersonname"
                  value={formData.reportedpersonname}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.reportedpersonname && (
                  <div className="invalid-feedback">
                    {validationErrors.reportedpersonname}
                  </div>
                )}
              </div>
              <div class="col-md-4">
                <label for="reportedpersoncontactno" class="form-label">
                  Reporter Mobile/landline No:
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.reportedpersoncontactno ? "is-invalid" : ""
                    }`}
                  id="reportedpersoncontactno"
                  value={formData.reportedpersoncontactno}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.reportedpersoncontactno && (
                  <div className="invalid-feedback">
                    {validationErrors.reportedpersoncontactno}
                  </div>
                )}
              </div>
              <div class="col-md-4">
                <label for="reporteddate" class="form-label">
                  Reported Date & Time<span className="text-danger">*</span>
                </label>
                <input
                  type="datetime-local"
                  className={`form-control branch-input-form-control ${validationErrors.reporteddate ? "is-invalid" : ""
                    }`}
                  id="reporteddate"
                  value={formData.reporteddate}
                  onChange={handleInputChange}
                />

                {validationErrors.reporteddate && (
                  <div className="invalid-feedback">
                    {validationErrors.reporteddate}
                  </div>
                )}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="slatarget" class="form-label">
                  SLA Target<span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control branch-input-form-control ${validationErrors.slatarget ? "is-invalid" : ""
                    }`}
                  id="slatarget"
                  value={formData.slatarget}
                  onChange={handleInputChange}
                // placeholder="Enter event name"
                />
                {validationErrors.slatarget && (
                  <div className="invalid-feedback">
                    {validationErrors.slatarget}
                  </div>
                )}
              </div>


<div className="col-md-6">
  <label htmlFor="assignedteam" className="form-label">
    Assigned Team<span className="text-danger">*</span>
  </label>
  <Select
    isMulti
    name="assignedteam"
    options={roleOptions}
    value={
      formData.assignedteam
        ? formData.assignedteam
          .split(",")
          .map((team) => {
            const option = roleOptions.find(
              (opt) =>
                opt.value.toString() === team.trim() ||
                opt.label === team.trim()
            );
            return option ? option : null;
          })
          .filter(Boolean)
        : []
    }
    onChange={(selected) => {
      const selectedValues = selected
        .map((option) => option.value)
        .join(",");
      setFormData({
        ...formData,
        assignedteam: selectedValues,
      });

      setValidationErrors({
        ...validationErrors,
        assignedteam: "",
      });
    }}
    classNamePrefix="react-select"
    className={validationErrors.assignedteam ? "is-invalid" : ""}
    // Add these props to fix z-index issues:
    menuPortalTarget={document.body}
    menuPosition="fixed"
    styles={{
      menuPortal: (base) => ({
        ...base,
        zIndex: 9999
      }),
      menu: (base) => ({
        ...base,
        zIndex: 9999
      })
    }}
  />
  {validationErrors.assignedteam && (
    <div className="invalid-feedback d-block">
      {validationErrors.assignedteam}
    </div>
  )}
</div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <label for="description" class="form-label">
                  Incident Description
                </label>
                <textarea
                  class="form-control"
                  id="description"
                  rows="3"
                  maxLength="250"
                // placeholder="Assign to relevant response team..."
                ></textarea>
                <small className="text-muted">Maximum 250 characters</small>
              </div>
              <div className="col-6" style={{ height: "50%" }}>
                {mapview && (
                  <div>
                    <MapWrapperForEdit
                      title="Incidents"
                      containerStyles={{
                        // height: "100vh",
                        display: "flex",
                        flexDirection: "column",
                      }}
                      headerStyles={{
                        backgroundColor: "#1a7a73",
                        color: "white",
                        padding: "8px 16px",
                      }}
                      bodyStyles={{
                        flex: 1,
                        overflow: "hidden",
                      }}
                      coordinates={mapCoordinates}
                      zoom={13}
                      popUpShow={true}
                    />
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginTop: "-22rem" }}>
              <div class="row mb-3">
                <div className="col-6">
                  <div className="d-flex justify-content-between align-items-center">
                    <label htmlFor="latitude" className="form-label mb-0">
                      Latitude
                    </label>
                  </div>
                  <input
                    type="text"
                    className="form-control branch-input-form-control mt-1"
                    id="latitude"
                    value={formData.latitude}
                    onChange={handleInputChange}
                    readOnly
                  />
                  {validationErrors.latitude && (
                    <div className="text-danger small">
                      {validationErrors.latitude}
                    </div>
                  )}
                </div>
              </div>

              <div class="row mb-3">
                <div className="col-md-6">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <label htmlFor="longitude" className="form-label">
                      Longitude
                    </label>
                    <span
                      className="text-primary"
                      onClick={!isTextFieldDisable ? openMapModal : undefined}
                      style={{
                        cursor: isTextFieldDisable ? "not-allowed" : "pointer",
                        opacity: isTextFieldDisable ? 0.5 : 1,
                      }}
                    >
                      Locate on map
                    </span>
                  </div>
                  <input
                    type="text"
                    className="form-control branch-input-form-control"
                    id="longitude"
                    value={formData.longitude}
                    onChange={handleInputChange}
                    readOnly
                  />
                  {validationErrors.longitude && (
                    <div className="text-danger small">
                      {validationErrors.longitude}
                    </div>
                  )}
                </div>
              </div>
              <div class="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="attachments" className="form-label">
                    Attachments (Images, Videos & Documents)
                  </label>
                  <input
                    type="file"
                    className="form-control branch-input-form-control"
                    id="attachments"
                    accept=".jpg, .jpeg, .png, .pdf, .mp4, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt"
                    onChange={handleImageChange}
                    multiple
                  />

                  <div className="mt-3 d-flex flex-wrap">
                    {selectedImages.map((fileObj, index) => {
                      const name = fileObj.preview || "";
                      const dotIndex = name.lastIndexOf(".");
                      const namePrefix = name.slice(0, 4);
                      const extension =
                        dotIndex !== -1 ? name.slice(dotIndex) : "";
                      const shortName = `${namePrefix}${extension}`;

                      return (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            margin: "5px",
                            display: "inline-block",
                            textAlign: "center",
                            width: "100px",
                          }}
                        >
                          {fileObj.type && fileObj.type.startsWith("image") ? (
                            <img
                              src={fileObj.preview}
                              alt={`preview-${index}`}
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "100px",
                                height: "100px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "4px",
                                backgroundColor: "#f0f0f0",
                              }}
                            >
                              {getFileIcon(fileObj.type)}
                            </div>
                          )}

                          <span
                            style={{
                              display: "block",
                              fontSize: "12px",
                              marginTop: "4px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                            title={name}
                          >
                            {shortName}
                          </span>

                          <button
                            onClick={() => removeImage(index)}
                            style={{
                              position: "absolute",
                              top: "-5px",
                              right: "-5px",
                              color: "black",
                              background: "white",
                              border: "none",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              cursor: "pointer",
                              fontSize: "12px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            title="Remove file"
                          >
                            ✖
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="d-flex justify-content-center"
            style={{ marginTop: "3rem" }}
          >
            <button
              className="branch-save-submit-btn btn btn-success"
              onClick={handleSubmit}
              disabled={isSubmitting || isTextFieldDisable}
            >
              {isSubmitting
                ? "Submitting..."
                : data
                  ? "Update"
                  : "Save & Submit"}
            </button>
          </div>

          {/* Display loading indicator */}
          {loader && (
            <div className="loader-container">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          {/* map modal */}
          {showMapModal && (
            <Modal
              className="modal-position"
              size="lg"
              show={showMapModal}
              onHide={closeMapModal}
              aria-labelledby="example-modal-sizes-title-lg"
              right
            >
              <Modal.Header>
                <Modal.Title
                  id="example-modal-sizes-title-lg"
                  style={{ color: "#001b30", marginRight: "500px" }}
                >
                  {"Choose Location"}
                </Modal.Title>
                <XCircleblack
                  className="cursor-pointer"
                  onClick={closeMapModal}
                  width="1.5em"
                  height="1.5em"
                  style={{ color: "#001b30" }}
                />
              </Modal.Header>
              <Modal.Body>
                <div className="gis-mapcontainer">
                  <LocationAutoComplete updateMapLocation={updateMapLocation} />

                  <div key={mapKey} className="assetFormMap">
                    <MapWrapper
                      headerStyles={{ display: "none" }}
                      coordinates={coordinates}
                      chooseCoordinates={chooseCoordinates}
                      zoom={zoomLevel}
                      closeMapModal={closeMapModal}
                    />
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          )}

          <ToastContainer />
        </>
      )}
      <Modal
        show={showCancelModal}
        onHide={closeCancelModal}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Would you like to clear the input values?</p>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "right" }}>
          <button
            className="btn"
            style={{
              backgroundColor: "lightgray",
              color: "#000",
              marginRight: "10px",
            }}
            onClick={closeCancelModal}
          >
            No
          </button>
          <button
            className="btn"
            style={{
              backgroundColor: "green",
              color: "#fff",
            }}
            onClick={confirmCancel}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateIncidentForm;
